export default __webpack_public_path__ + "static/media/Crio-certificate.9e721213.jpg";